import Vue from "vue";
import App from "./App"
import VueRouter from "vue-router";
import store from "./store"
import Toast from "vue-toastification";
import "@/utils/validation";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import systemApi from "@/api/systemApi";
import router from "@/router/router";
import { actionTypes, commitTypes, dbName } from "@/store-types";
import "bootstrap-css-only/css/bootstrap.min.css"
import "mdbvue/build/css/mdb.css"
import "@fortawesome/fontawesome-free/css/all.min.css"
import VueToastr from "vue-toastr"

import wb from "./registerServiceWorker";
Vue.prototype.$workbox = wb;

Vue.config.productionTip = false;

Vue.use(VueRouter);

Vue.use(VueToastr, {
    defaultTimeout: 3000,
    defaultProgressBar: false,
    defaultProgressBarValue: 0,
    defaultType: "success",
    defaultPosition: "toast-bottom-right",
    defaultCloseOnHover: false,
    // defaultStyle: { "background-color": "red" },
    defaultClassNames: ["animated", "zoomInUp"]
});

// ******** validation ********
// vee-validate common components
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

// ******** directives ********
// v-integer and v-decimal
// Vue.use(NumericDirective);

import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
Vue.component('date-picker', VuePersianDatetimePicker);

// ******** other components ********
Vue.use(Toast, {
    timeout: 2000,
});

import filters from './filter/filters.js';
for (let name in filters) {
    Vue.filter(name, filters[name]);
}

import notificationApi from "@/api/notificationApi"
import { getMessaging, getToken } from "firebase/messaging";
import { getAnalytics, logEvent, setUserId } from "firebase/analytics";
import { initializeApp } from "firebase/app";

// import * as firebase from 'firebase/app';
const firebaseConfig = {
    apiKey: "AIzaSyAFLwXStJ5caTDtmEv3hOyq4NtQG5Ds1No",
    authDomain: "bndb-190a6.firebaseapp.com",
    databaseURL: "https://bndb-190a6.firebaseio.com",
    projectId: "bndb-190a6",
    storageBucket: "bndb-190a6.appspot.com",
    messagingSenderId: "118839167879",
    appId: "1:118839167879:web:5ef1369c6ac13cc7d0e122",
    measurementId: "G-8D4C7BZ6ZL"
};

import { getDatabase, ref, set } from "firebase/database";


store.dispatch(actionTypes.APP_LOAD)
    .then(() => store.dispatch(actionTypes.LOAD_LOCATION)
        .then(() => store.dispatch(actionTypes.CHECK_TOKEN)
            .then(() => store.dispatch(actionTypes.LOAD_USER_DATA)
                .then(() => {
                    store.subscribe((mutation, state) => {
                        console.log("save state");
                        localStorage.setItem(dbName.DB_STATE, JSON.stringify(state));
                    });

                    // configure the router navigation guards to check auth before following routes on each navigation event
                    // roles are assigned to routes in routes.js
                    router.beforeEach((to, from, next) => {
                        // public routes, no access value set or it's set to *
                        if (!Object.prototype.hasOwnProperty.call(to.meta, "access") || to.meta.access.includes("*")) {
                            console.log("allow");
                            next();
                            return;
                        }

                        // private route, users that aren't signed in go to login
                        // console.log("check state", store.state);
                        if (!store.state.signedIn) {
                            // store the path they were trying to go so we can send them there after login
                            console.log("don't sign "+to.name + " "+to.params);
                            console.log(to);
                            store.commit(commitTypes.SET_REDIRECT, { name: to.name, params: to.params });
                            next({ name: "UserLogin" });
                            return;
                        }

                        // user doesn't have the correct role
                        if (!to.meta.access.includes(store.state.user.Role)) {
                            console.log("don't role", to.meta.access, store.state.user.Role);
                            next({ name: "UserLogin" });
                            return;
                        }

                        // correct roles, continue
                        next();
                    });

                    const app = initializeApp(firebaseConfig);
                    const messaging = getMessaging();
                    getToken(messaging, { vapidKey: 'BGSOpQR1b2PHCY8AU_LF2vvLZg_rfCT1JgyXkTFoZtRSyJWLqnFtniKlkCBsF52kHfmqS27V_hmRBKGUNsM3s_k' })
                        .then((currentToken) => {
                            if (currentToken) {

                                console.log(currentToken);

                                if (store.state.signedIn) {
                                    var token = store.state.notificationToken;
                                    if (token != currentToken) {
                                        notificationApi.setNotificationToken({ Token: currentToken })
                                            .then(({ data }) => {
                                                    if (data.Status == 1) {
                                                        store.state.notificationToken = currentToken;
                                                    } else {
                                                        this.$toastr.s("فعالسازی نوتیفیکیشن شما در حال حاضر ممکن نیست. لطفاً بعداً تلاش فرمایید.","نوتیفیکشن");
                                                    }
                                                },
                                                (r) => {});
                                    }
                                }

                            } else {
                                console.log('No registration token available. Request permission to generate one.');
                            }
                        }).catch((err) => {
                            console.log('An error occurred while retrieving token. ', err);
                        });

                    // const analytics = getAnalytics(app);
                    const db = getDatabase(app);

                    // logEvent(analytics, "load", { action: 'App', event: 'mounted' });

                    // if (store != null && store.state.signedIn == true) {
                    //     var userId = store.state.user.UserId;
                    //     // console.log('userId', userId);
                    //     setUserId(analytics, userId);
                    // }

                    // Vue.prototype.$app = app;
                    // create the main Vue instance
                    new Vue({
                        router,
                        store,
                        app,
                        components: { App },
                        render: h => h(App,{ props: { app,store } })
                    }).$mount('#app');

                    // GLOBAL ERROR LOGGING AND HANDLING
                    // this sends client-side errors to the server for logging in the database

                    // don't send errors to the API in development
                    // if (process.env.NODE_ENV === "development") {
                    //     console.log("Error recording disabled for development");
                    //     return;
                    // }

                    // Vue errors
                    Vue.config.errorHandler = (err, vm, info) => {
                        const e = {
                            error: JSON.parse(JSON.stringify(err, Object.getOwnPropertyNames(err))),
                            vm: vm ? {
                                name: vm.name,
                                route: vm.$router.currentRoute.fullPath,
                                tag: vm.$vnode.tag,
                            } : {},
                            info: info,
                        };

                        const logInfo = { source: "Router", user: null, data: e };
                        var userId = 0;
                        if (store != null && store.state.signedIn == true) {
                            userId = store.state.user.UserId;
                            logInfo.user = store.state.user;
                        }
                        // console.error('save log');
                        set(ref(db, 'users/' + userId), logInfo)
                            .then(() => {
                                console.log("Log...",logInfo);
                            })
                            .catch((error) => {
                                console.error(error);
                            });
                        // logEvent(analytics, logInfo);
                        // try {
                        //     api.log(logInfo);
                        // } catch (x) {
                        //     console.log(logInfo);
                        // }

                        return false;
                    };

                    // global JS error logging
                    window.addEventListener("error", (err) => {
                        const e = {
                            error: JSON.parse(JSON.stringify(err, Object.getOwnPropertyNames(err))),
                        };

                        // const logInfo = { source: "Global Errors", user: store.state.user, data: e };
                        const logInfo = { source: "Router", user: null, data: e };
                        var userId = 0;
                        if (store != null && store.state.signedIn == true) {
                            userId = store.state.user.UserId;
                            logInfo.user = store.state.user;
                        }
                        // console.error('save log');
                        set(ref(db, 'users/' + userId), logInfo)
                            .then(() => {
                                console.log("Log...",logInfo);
                            })
                            .catch((error) => {
                                console.error(error);
                            });

                        // logEvent(analytics, logInfo);
                        // try {
                        //     systemApi.log(logInfo);
                        // } catch (x) {
                        //     console.log(logInfo);
                        // }
                    });

                    // unhandled Promise rejection error logging
                    window.addEventListener("unhandledrejection", (err) => {
                        const e = {
                            error: JSON.parse(JSON.stringify(err, Object.getOwnPropertyNames(err))),
                        };

                        // const logInfo = { source: "Unhandled Rejections", user: store.state.user, data: e };

                        const logInfo = { source: "Router", user: null, data: e };
                        var userId = 0;
                        if (store != null && store.state.signedIn == true) {
                            userId = store.state.user.UserId;
                            logInfo.user = store.state.user;
                        }
                        // console.error('save log');
                        set(ref(db, 'users/' + userId), logInfo)
                            .then(() => {
                                console.log("Log...",logInfo);
                            })
                            .catch((error) => {
                                console.error(error);
                            });

                        // logEvent(analytics, logInfo);
                        // try {
                        //     systemApi.log(logInfo);
                        // } catch (x) {
                        //     console.log(logInfo);
                        // }
                    });
                }))));